import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import MemberIcon from "../member-icon/member-icon";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import GroupIcon from '../../assets/icons/Icons - Groups.svg';

import "./member-dropdown.scss";

const MemberDropdown = ({
  index,
  member,
  type,
  filter,
  toggleRow,
  selectedMembers,
  rowFilter,
  taskType,
  projects,
  isGroup,
  classNameAddition
}) => {
  const [className] = useState(classNameAddition ? classNameAddition : ''); 
  const [checked, setChecked] = useState(false);
  const [name, setName] = useState(member.userNameFull || '');

  useEffect(() => {

    //CALL THIS WHENEVER SEARCH BAR IS CLICKED
    for (let i = 0; i < selectedMembers.length; i++) {
      if (selectedMembers[i].userID === member.userID) {
        setChecked(true);
        break;
      }
      else{
        setChecked(false)
      }
    }
    if (selectedMembers.length === 0) {
      setChecked(false);
    }
    let newName = "";
    if (member.userNameFull.length > 30) {
      for (let i = 0; i < 27; i++) {
        newName = newName.concat(member.userNameFull[i]);
      }
      newName = newName.concat("...");
    } else {
      newName = member.userNameFull;
    }
    setName(newName);
  }, [member, type, filter, toggleRow, selectedMembers, rowFilter, taskType]);


  const toggleChecked = (e) => {
    toggleRow(member, !checked);
    setChecked(!checked);
  };

  const overlayString = () => {
    if (('groupID' in member) && (member.groupID)) {
      return groupHover();
    }


    else if(!('strRole' in member)){
      return name + " (" + member.role +")" + " - " + member.company + " - " + (!projects? (member.userEmail || member.emailID) : '');
    }

    else {
      
     return name + " (" + member.strRole +")" + " - " + (!projects? member.strCompany : member.company) + (!projects? ' - ' : '') + (!projects? member.userEmail : '');
      //else 
    }
  }

  const groupHover = () => {
    if (('groupID' in member) && (member.groupID !== null)){
      if (('groupHover' in member) || (isGroup === true)){
        return member.groupHover;
      }
      else {
        let hoverStr = "";
        member.groupMember.forEach(groupMember  => {
          hoverStr += groupMember.userName + " (" + groupMember.role +")" + " - " + groupMember.company  + "\n"
        });
        return hoverStr;
      }
    }
    else{
      return "";
    }

  }

  const formatName = () => {
    if (type === "user" && !filter) {
      if (name.length < 6) {
        return name;
      } else {
        return name.substring(0, 6) + "...";
      }
    } else {
      if (name.length < 12) {
        return name;
      } else {
        return name.substring(0, 12) + "...";
      }
    }
  }

  return (
    <div >
        <Form.Check className={`${!projects ? 'member-dropdown-row' : 'member-dropdown-row-small'}${className}`}>
          {filter ? (
            <Form.Check.Input
              className={`member-dropdown-row-checkbox${className}`}
              type="checkbox"
              checked={checked}
              disabled={!filter}
              onClick={(e) => toggleChecked(e)}
            />
          ) : (
            <></>
          )}

            <div className='member-name-icon-container'>
              <div className={`member-dropdown-row-user-icon${className}`}>
                {
                  <MemberIcon
                    type={type}
                    member={member}
                    extraMembers={0}
                  ></MemberIcon>
                }
              </div>

              <div className='member-name-email-department-container'>
                <OverlayTrigger placement="right" delay={{ show: 150, hide: 150 }} trigger={['hover', 'focus']} overlay={
                  <Tooltip id={`tooltip-${index}`} >
                      {overlayString()}
                  </Tooltip>
                }>
                  <div className={`member-dropdown-row-name${className}`}>
                    {formatName()} {(type === "user" && !filter) ? "(Owner)" : ""} 
                    {member.groupID ? <img className='group-icon' alt='group icon' src={GroupIcon}/> : <></>} 
                  </div>
                </OverlayTrigger>
                
                {projects && 
                  <>
                    <div className='member-dropdown-info'>{member.userEmail}</div>
                    <div className='member-dropdown-info'>{member.company}</div>
                  </>  
                }
              </div>
            </div>

          {member.assign && !filter || (member.permission === "edit") || (member.permission === "assign") ? (
            taskType === 0 ?
            <div className='icon-permission-container'>
              {/* <div className={`member-dropdown-row-edit-icon${""}`}></div> */}
              <div className={`member-dropdown-row-edit-text-icon${""}`}>
                Edit
              </div>
            </div>
            :
            <div className='icon-permission-container'>
              {/* <div className={`member-dropdown-row-assign-icon${""}`}></div> */}
              <div className={`member-dropdown-row-assign-text-icon${""}`}>
                Assign
              </div>
            </div>
            
          ) : (
            ""
          )}
          {(member.view && !filter) || (member.permission === "view") ? (
            <div className='icon-permission-container'>
              {/* <div className={"member-dropdown-row-view-icon"}></div> */}
              <div className={"member-dropdown-row-view-text-icon"}>View</div>
            </div>
          ) : (
            ""
          )}
          {member.approve && !filter || (member.permission === "approve") ? (
            <div className='icon-permission-container'>
              {/* <div className={"member-dropdown-row-approve-icon"}></div> */}
              <div className={"member-dropdown-row-icon"}>Approve</div>
            </div>
          ) : (
            ""
          )}
          {member.publish && !filter || (member.permission === "publish") ?  (
            <div className='icon-permission-container'>
              <div className={"member-dropdown-row-publish-text-icon"}>
                Publish
              </div>
            </div>
          ) : (
            ""
          )}
          {member.owner && !filter ? (
            <div className='icon-permission-container'>
              {/* <div className={"member-dropdown-row-approve-icon"}></div> */}
              <div className={"member-dropdown-row-icon"}>Approve</div>
            </div>
          ) : (
            ""
          )}
        </Form.Check>
    </div>
  );
};

export default MemberDropdown;
